import { useEffect, useRef, useState } from 'react';
import { grabaZonasPorCliente, recuperaZonasPorCliente } from '../../services/Siniestro/SiniestroService';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

const AsignaZonas = ({ datCliente, funcSalir }) => {
    const [seleccionados, setSeleccionados] = useState([]);
    const [disponibles, setDisponibles] = useState([]);
    const [guarda, setGuarda] = useState(false);

    const asocToast = useRef();

    useEffect(() => {
        const recuperaZonas = async () => {
            if (datCliente?.configuracionDetId) {
                try {
                    const data = await recuperaZonasPorCliente(datCliente?.configuracionDetId);
                    //console.log('DATOS RECUPERADOS... : ', data);
                    const iniSelect = data.filter((item) => item.esDelCliente === true);
                    const iniDispo = data.filter((item) => item.esDelCliente === false);
                    setSeleccionados(iniSelect);
                    setDisponibles(iniDispo);
                } catch (error) {
                    console.error('Error al recuperar Zonas');
                }
            }
        };
        recuperaZonas();
    }, [datCliente?.configuracionDetId]);

    const marcarProyecto = (rowData) => {
        //
        setDisponibles((prev) => prev.filter((item) => item.ubicacionId !== rowData.ubicacionId));
        setSeleccionados((prev) => [...prev, { ...rowData, seleccion: true }]);
    };

    const desmarcarProyecto = (rowData) => {
        //
        setSeleccionados((prev) => prev.filter((item) => item.ubicacionId !== rowData.ubicacionId));
        setDisponibles((prev) => [...prev, { ...rowData, seleccion: false }]);
    };

    const templateSeleccionBody = (rowData) => <Checkbox onChange={() => desmarcarProyecto(rowData)} checked={true} />;
    const templateDisponibleBody = (rowData) => <Checkbox onChange={() => marcarProyecto(rowData)} checked={false} />;

    const handleGuardar = async () => {
        //console.log('GUARDANDO')
        try {
            setGuarda(true);
            const lstUbicacionIds = seleccionados.map((item) => item.ubicacionId);
            const salida = await grabaZonasPorCliente(datCliente?.configuracionDetId, lstUbicacionIds);
            if (salida === 'OK') {
                asocToast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se han actualizado las relaciones'
                });
            }
        } catch (error) {
            //console.error ('ERROR: al guardar Asociacion')
            asocToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se han guardado las relaciones'
            });
        } finally {
            setGuarda(false);
            funcSalir();
        }
    };

    const [filtrosSelec, setFiltrosSelec] = useState({
        global: { value: null, matchMode: 'contains' },
        nombreUbicacion: { value: null, matchMode: 'contains' }
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltrosSelec, setValoresFiltrosSelec] = useState({
        nombreUbicacion: '',
        global: ''
    });

    const textoFilterTemplateSelec = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosSelec[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltrosSelec((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosSelec };
                        newFilters[field].value = nuevoValor;
                        setFiltrosSelec(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    const [filtrosDispo, setFiltrosDispo] = useState({
        global: { value: null, matchMode: 'contains' },
        nombreUbicacion: { value: null, matchMode: 'contains' }
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltrosDispo, setValoresFiltrosDispo] = useState({
        nombreUbicacion: '',
        global: ''
    });

    const textoFilterTemplateDispo = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosDispo[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltrosDispo((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosDispo };
                        newFilters[field].value = nuevoValor;
                        setFiltrosDispo(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    return (
        <div className="card">
            <Toast ref={asocToast} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-3 mb-3">
                    <label>Nombre del Cliente: </label>
                </div>
                <div className="field col-9 mb-3">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        {datCliente?.nombre}
                    </span>
                </div>
                <div className="field col-5 mb-3">
                    <h5>Zonas Asignadas</h5>
                    <DataTable
                        value={seleccionados}
                        emptyMessage="No hay Zonas Seleccionadas"
                        showGridlines
                        size="small"
                        tableStyle={{ tableLayout: 'fixed', minWidth: '30rem' }}
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 20]}
                        responsiveLayout="scroll"
                        filters={filtrosSelec}
                        filterDisplay="row"
                    >
                        <Column header="Check" body={templateSeleccionBody} style={{ width: '10%' }} />
                        <Column
                            header="Nombre"
                            field="nombreUbicacion"
                            style={{ width: '90%' }}
                            filter
                            filterPlaceholder="Filtro Nombre"
                            filterElement={(options) => textoFilterTemplateSelec(options, 'nombreUbicacion')}
                        />
                    </DataTable>
                </div>
                <div className="field col-1 mb-3">
                    <Divider layout="vertical" />
                </div>
                <div className="field col-5 mb-3">
                    <h5>Zonas Disponibles</h5>
                    <DataTable
                        value={disponibles}
                        emptyMessage="No hay Zonas disponibles"
                        showGridlines
                        size="small"
                        tableStyle={{ tableLayout: 'fixed', minWidth: '30rem' }}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 300]}
                        responsiveLayout="scroll"
                        filters={filtrosDispo}
                        filterDisplay="row"
                    >
                        <Column header="Check" body={templateDisponibleBody} style={{ width: '10%' }} />
                        <Column
                            header="Nombre"
                            field="nombreUbicacion"
                            style={{ width: '90%' }}
                            filter
                            filterPlaceholder="Filtro Nombre"
                            filterElement={(options) => textoFilterTemplateDispo(options, 'nombreUbicacion')}
                        />
                    </DataTable>
                </div>
                <div className="field col-10 mb-3">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-2 mb-3">
                    <Button label="Guardar" icon="pi pi-save" onClick={handleGuardar} loading={guarda} />
                </div>
            </div>
            <span>Hola</span>
        </div>
    );
};

export default AsignaZonas;
